import React from 'react'
import RecentItem from '../RecentItem/RecentItem'

import styles from './SubscriptionIntro.module.css'

const SubscriptionIntro = () => {
  return (
    <div className={styles['info-wrapper']}>
      <RecentItem />
      <div className={styles['premium-info']}>
        <p>
          Premium lets you play any movie or series anytime. No restrictions.
        </p>
        <p className={styles['upgrade']}>Upgrade to Premium</p>
        <div>
          <p className={styles['profit']}>Unlock Premium Content</p>
          <p className={styles['profit']}>Get Access to latest releases</p>
          <p className={styles['profit']}>Unlimited Plays</p>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionIntro
